import $ from 'jquery';
let target = window.location.hash;
target = target.replace('#', '');
window.location.hash = '';
$(window).on('load', function () {
  if (target) {
    if ($('[data-cat="' + target + '"]').hasClass('js-product')) {
      $('[data-cat="' + target + '"]').trigger('click');
      $('html, body').animate(
        {
          scrollTop:
            $('#list_manufacturers').offset().top -
            $('.c-header').outerHeight(),
        },
        1000,
        'swing',
        function () {},
      );
    } else {
      $('html, body').animate(
        {
          scrollTop:
            $('#' + target).offset().top - $('.c-header').outerHeight(),
        },
        1000,
        'swing',
        function () {},
      );
    }
  }
  $('.js-accordion').each(function () {
    $('.js-accordionHeading', this).trigger('click');
  });
});

$('.js-header-line').on('click', function (e) {
  let hashIndex = $(this).attr('href').split('#')[1];
  $('.js-closeMenu').trigger('click');
  let $headerLine = $(this);
  setTimeout(function () {
    if ($headerLine.hasClass('c-header__submenu2__txt')) {
      $('[data-cat="' + hashIndex + '"]').trigger('click');
      $('html, body').animate(
        {
          scrollTop:
            $('#list_manufacturers').offset().top -
            $('.c-header').outerHeight(),
        },
        1000,
        'swing',
        function () {},
      );
    } else {
      $('[data-cat="all"]').trigger('click');
      $('html, body').animate(
        {
          scrollTop:
            $('#' + hashIndex).offset().top - $('.c-header').outerHeight(),
        },
        1000,
        'swing',
        function () {},
      );
    }
  }, 400);
  return false;
});

let windowWidth = $(window).width();
if(windowWidth < 768){
  $('.c-navi6__arrow').on('click', function(){
    $(this).toggleClass('is-open');
    $(this).parent().toggleClass('is-open');
  })
}
